import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdf4f784"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "QuotaAdjustment__title" }
const _hoisted_2 = {
  key: 0,
  class: "QuotaAdjustment__tabs"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "设置无限额度后该车辆加油将直接扣减企业账户余额。", -1))
const _hoisted_4 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_available_quota = _resolveComponent("available-quota")!
  const _component_regular_quota = _resolveComponent("regular-quota")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
    width: "656px",
    height: "474px",
    footer: null,
    onCancel: _ctx.closeModal
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("b", null, _toDisplayString(_ctx.modalType === 'department' ? '部门' : '') + "额度管理", 1),
        _createTextVNode(" - " + _toDisplayString(_ctx.modalType === 'car' ? `（${_ctx.rowDetail.licensePlate || _ctx.rowDetail.vin || ''}）` :
          _ctx.modalType === 'person' ? `（${_ctx.rowDetail.userName}）`:
          _ctx.modalType === 'department' ? `（${_ctx.rowDetail.departmentName}）` : ''), 1)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.modalType === 'car')
        ? (_openBlock(), _createBlock(_component_a_radio_group, {
            key: 0,
            value: _ctx.quotaFlag,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quotaFlag) = $event)),
            class: "quotaType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, {
                value: 0,
                style: {"padding-right":"50px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("设置额度")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("无限额度")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        (!_ctx.isScheduleModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_a_radio_group, {
                value: _ctx.switchValue,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.switchValue) = $event)),
                size: "large",
                "button-style": "solid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_button, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("可用额度")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio_button, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("定期额度")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_available_quota, {
          ref: "AvailableQuotaRef",
          "row-detail": _ctx.rowDetail,
          onCloseModal: _ctx.closeModal
        }, null, 8, ["row-detail", "onCloseModal"]), [
          [_vShow, _ctx.switchValue === 1]
        ]),
        _withDirectives(_createVNode(_component_regular_quota, {
          ref: "RegularQuotaRef",
          "row-detail": _ctx.rowDetail,
          onCloseModal: _ctx.closeModal
        }, null, 8, ["row-detail", "onCloseModal"]), [
          [_vShow, _ctx.switchValue === 2]
        ])
      ], 512), [
        [_vShow, _ctx.quotaFlag === 0]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"14px"},
            onClick: _ctx.closeModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.quotaFlag === 1]
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}